import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const TextInput = (props) => {
    return (
        <div className="relative">
            <input
                className={`${props.className} w-full ${props.isPassword ? "pr-10" : ""}`}
                placeholder={props.placeholder}
                type={
                    props.isPassword
                        ? props.showPassword ? "text" : "password"
                        : props.type
                }
                name={props.name}
                value={props.value}
                min={props.min}
                max={props.max}
                maxLength={props.maxLength}
                onChange={(event) => props.handleChange(event, props.identity)}
                onBlur={props.onBlur ? (e) => props.onBlur(props.identity) : undefined}
                disabled={props.disabled === true}
                autoComplete={props.autoComplete ? props.autoComplete : "off"}
                onClick={(event) => props.handleOnClick ? props.handleOnClick(event, props.identity) : null}
                checked={props.checked !== null ? props.checked : ""}
            />

            {props.isPassword && (
                <span
                    className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-600"
                    onClick={props.togglePassword}
                >
                    <FontAwesomeIcon icon={props.showPassword ? faEyeSlash : faEye} />
                </span>
            )}
        </div>
    );
};

export default TextInput;
